import React, { useState, useEffect } from 'react';
import './ImgCarousel.css';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ImageCarousel: React.FC = () => {
    const navigate = useNavigate();
    const [images] = useState([
        {
            url: '/Assets/carousel13.jpg',
            title: 'Imagen 1',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        },
        {
            url: '/Assets/faro.jpeg',
            title: 'Imagen 2',
            description: 'Los sabios son precavidos y evitan el peligro; los necios, confiados en sí mismos, se precipitan con imprudencia. Proverbios 14:16-17.',
        },
        {
            url: '/Assets/Carousel3.jpeg',
            title: 'Imagen 3',
            description: 'En Roca Seguros estás en las mejores manos para planificar tu futuro, proteger tu patrimonio, anticipar imprevistos y evitar preocupaciones, tomando el control del mañana y dándote la tranquilidad que necesitas para disfrutar de cada momento.',
        },
    ]);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 6000);

        return () => clearInterval(interval);
    }, [images]);

    return (
        <div className="image-slider">
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`slider-item ${index === currentImageIndex ? 'active' : ''}`}
                    style={{
                        backgroundImage: `url(${image.url})`,
                    }}
                >
                    <div className="carousel-overlay">
                        <div className="text-container">
                            <Typography
                                sx={{
                                    color: '#ff6c00',
                                    fontFamily: 'Inter, sans-serif',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    marginBottom: '5px'
                                }}
                            >
                                SOLUCIONES INTEGRALES EN SEGUROS
                            </Typography>
                            <div className="title">
                                <Typography
                                    sx={{
                                        color: '#ffffff',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '58px',
                                            '@media (max-width: 700px)': {
                                                fontSize: '40px',
                                            },
                                        fontWeight: '700',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Aseguramos su tranquilidad
                                </Typography>
                            </div>
                            <Typography
                                sx={{
                                    color: '#ffffff',
                                    fontFamily: 'Inter, sans-serif',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                }}
                            >
                                En Roca Seguros, te ofrecemos una asesoría personalizada y efectiva. Te acompañamos en cada paso para proteger lo que más valoras.
                            </Typography>
                            
<button className='us-button' style={{ marginTop: '5px' }} onClick={() => navigate('/Nosotros')}>
                                <span>Conoce más</span>
                            </button>
                        </div>
                    </div>                   
                </div>
            ))}
        </div>
    );
};

export default ImageCarousel;
